export const getSWCacheVersion = async (): Promise<string> => {
  const versionFileUrl = import.meta.env.VITE_PUBLIC_URL + "/version.json";
  const response = await fetch(versionFileUrl);
  const { version } = await response.json();
  return version;
};
